import React, {useEffect, useState} from "react";
import axios from "axios";

const Users = () => {
    const [Users, setUsers] = useState(undefined)
    const [Admin, setAdmin] = React.useState(false);

    let email

    useEffect( () => {
        const getAll = async () => {
            try {
                const users = await axios.get(`/api/user/get`);
                setUsers(users.data);
            } catch (error) {
                console.log(error);
            }
        }
        const checkAuth = async () => {
            try {
                const response = await axios.get('/api/auth/validate-token', { withCredentials: true });
                const user = response.data.user.organization;
                if (user === "admin") {
                    setAdmin(true)
                }
            } catch (error) {
                console.log(error)
            }
        };

        getAll();
        checkAuth();
    }, []);

    const DeleteMachine = async () => {
        if (Admin) {
            document.getElementById("popup").style.display = "none";
            window.location.reload();
            await axios.delete(`/api/user/delete`, {
                params: {
                    email: email,
                }
            });
        }
    }

    const confirmDeleteMachine = async (event, Email) => {
        document.getElementById("popup").style.display = "flex";
        email = Email;
    }

    const cancelDeleteMachine = async () => {
        document.getElementById("popup").style.display = "none";
    }

    return (
        <div className={"flex px-24"}>
            {Admin ? <dialog open id={"popup"}
                             className={"hidden shadow-sm shadow-gray-400 bg-gray-200 rounded-2xl p-3 w-72 fixed z-50 text-center gap-4 flex-col"}>
                <p className={"font-bold text-2xl"}>Weet je zeker dat je dit account wilt verwijderen</p>
                <div className="flex items-center justify-around">
                    <button className={"p-2 bg-blue-500 rounded-full text-xl font-bold text-white w-16"}
                            onClick={DeleteMachine}>Ja
                    </button>
                    <button className={"p-2 bg-blue-500 rounded-full text-xl font-bold text-white w-16"}
                            onClick={cancelDeleteMachine}>Nee
                    </button>
                </div>
            </dialog> : null}
            <a href={"/"} className={"ml-2 mt-2 font-extrabold left-4 text-xl text-white absolute bg-orange-500 rounded-lg h-fit p-1.5 shadow-xl shadow-gray-400"}>Terug</a>
            <ul className={"flex flex-col w-full items-center"}>
                {Users ? Users.map((user) => (
                    <li key={user.email} className="flex flex-col p-4 items-center relative gap-3 border-b xl:w-1/2 md:w-3/4 w-10/12 border-stone-800">
                        <div className={"text-2xl font-bold"}>{user.email}</div>
                        <div className={"text-xl font-bold"}>{user.organization}</div>
                        {Admin ? <div className={"flex lg:flex-col sm:absolute bottom-3 flex-row right-3 lg:top-0 text-center gap-4"}>
                            <a onClick={(event) => confirmDeleteMachine(event, user.email)}
                               className={"hover:cursor-pointer bg-red-600 text-white rounded p-2"}>Delete</a>
                            {/*<a href={"edit/" + serialNumber}*/}
                            {/*   className={"hover:cursor-pointer bg-blue-500 text-white rounded p-2"}>Edit</a>*/}
                        </div> : null}
                    </li>
                )) : ""}
            </ul>

        </div>
    )
}

export default Users;